import React, { FC, useEffect } from 'react';
import { ErrorAlert } from '@ui/components/atoms';
import FormContainerStyles from './FormContainer.module.scss';

export const FormContainer: FC<{ error?: string; isIbsRequestForm?: boolean }> = ({
  children,
  error,
  isIbsRequestForm,
}) => {
  useEffect(() => {
    if (error) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [error]);
  return (
    <form
      className={
        !isIbsRequestForm
          ? FormContainerStyles.form_container
          : FormContainerStyles.form_container_IBS
      }
    >
      {error && (
        <div className="mt-5 w-100 d-flex justify-content-center align-items-center">
          <ErrorAlert message={error ?? 'Something went wrong'} />
        </div>
      )}
      {children}
    </form>
  );
};
